import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AllRouting from './AllRouting';
import './App.css';
import WhatsAppFloatingButton from './components/Common/WhatsAppFloatingButton';
import Footer from './components/Footer/Footer';
import Newsletter from './components/Footer/Newsletter';
import Navbar from './components/Header/Navbar';
import CartContext from './contexts/CartContext';
import UserContext from './contexts/UserContext';
import useFacebookPixel from './utils/useFacebookPixel';
const App = () => {
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState([]);
  const facebookPixel = useFacebookPixel();
  const saveCartToLocalStorage = (cartData) => {
    localStorage.setItem('cart', JSON.stringify(cartData));
  };
  useEffect(() => {
    const token = localStorage.getItem('userID');
    setUser(token);
  }, []);
  useEffect(() => {
    if (cart.length === 0) {
      const storedCart = localStorage.getItem('cart');
      if (storedCart) {
        const parsedCart = JSON.parse(storedCart);
        setCart(parsedCart);
      }
    }
  }, []);
  useEffect(() => {
    if (cart.length > 0) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
  }, [cart]);
  const addToCart = (product, quantity, selectedVariant) => {
    const updatedCart = [...cart];
    const productIndex = updatedCart.findIndex(
      (item) =>
        item.product.product_id === product.product_id &&
        item.variant.p_v_id === selectedVariant.p_v_id
    );
    if (productIndex === -1) {
      updatedCart.push({
        product: product,
        quantity: quantity,
        variant: selectedVariant,
      });
      toast.success('product Added to cart');

      if (facebookPixel) {
        facebookPixel.trackEvent('AddToCart', {
          content_ids: [product.product_id],
          content_type: 'product',
        });
      }
    } else {
      updatedCart[productIndex].quantity += quantity;
      toast.success('Cart updated successfully');
    }
    setCart(updatedCart);
  };
  const updateCart = (type, productId, variantId) => {
    const updatedCart = [...cart];
    const productIndex = updatedCart.findIndex(
      (item) =>
        item.product.product_id === productId ||
        item.variant.p_v_id === variantId
    );
    if (type === 'increase') {
      updatedCart[productIndex].quantity += 1;
      setCart(updatedCart);
    }
    if (type === 'decrease') {
      updatedCart[productIndex].quantity -= 1;
      setCart(updatedCart);
    }
  };
  const removeFromCart = (productId, variantId) => {
    const newCart = cart.filter(
      (item) =>
        item.product.product_id !== productId ||
        item.variant.p_v_id !== variantId
    );
    setCart(newCart);
    saveCartToLocalStorage(newCart);
    if (facebookPixel) {
      facebookPixel.trackEvent('RemoveFromCart', {
        content_ids: [productId],
        content_type: 'product',
      });
    }
  };
  const clearCart = () => {
    setCart([]);
    localStorage.removeItem('cart');
  };
  return (
    <>
      <UserContext.Provider value={{ user, setUser }}>
        <CartContext.Provider
          value={{
            cart,
            addToCart,
            removeFromCart,
            updateCart,
            setCart,
            clearCart,
          }}
        >
          <Navbar />
          <AllRouting />
          <Newsletter />
          <Footer />
          <ToastContainer
            position="top-right"
            autoClose={1500}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
          />
          <WhatsAppFloatingButton />
        </CartContext.Provider>
      </UserContext.Provider>
    </>
  );
};
export default App;
